import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25dd7185"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "#kt_header_menu",
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  "data-kt-menu": "true"
}
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-content pt-8 pb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "menu-section text-muted text-uppercase fs-8 ls-1 fw-boldest" }, " Doc ")
], -1))
const _hoisted_5 = { style: {"position":"absolute","right":"5px","top":"30px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner spinner-success mr-15",
  style: {"position":"absolute","right":"-6px","top":"-2px"}
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus-circle fw-boldest fa-2x",
  style: {"float":"right"}
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { style: {"position":"absolute","right":"20px","top":"0px"} }
const _hoisted_10 = {
  style: {"display":"none"},
  class: "menu-item-custom-action"
}
const _hoisted_11 = { class: "menu-item px-3" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "menu-item px-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { style: {"position":"absolute","right":"20px","top":"0px"} }
const _hoisted_20 = {
  style: {"display":"none"},
  class: "menu-item-custom-action-child"
}
const _hoisted_21 = { class: "menu-item px-3" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "menu-sub menu-sub-accordion menu-active-bg" }
const _hoisted_28 = {
  key: 0,
  style: {"position":"absolute","right":"20px","top":"0px"}
}
const _hoisted_29 = {
  style: {"display":"none"},
  class: "menu-item-custom-action-child-last"
}
const _hoisted_30 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "card" }
const _hoisted_35 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_QuickAction = _resolveComponent("QuickAction")!
  const _component_ShortPageForm = _resolveComponent("ShortPageForm")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addCollection && _ctx.addCollection(...args)))
            }, _hoisted_8)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass(["menu-item menu-accordion menu-item-submenu menu-item-custom menu-item menu-accordion", {'hover active': item.active}]),
            style: {"position":"relative"}
          }, [
            _createVNode(_component_MenuItem, {
              item: item,
              onClick: ($event: any) => (_ctx.onClickItem(item))
            }, null, 8, ["item", "onClick"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_QuickAction, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        class: "menu-link px-3",
                        onClick: ($event: any) => (_ctx.addFolder(item.id))
                      }, "Add Folder", 8, _hoisted_12)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        class: "menu-link px-3",
                        onClick: ($event: any) => (_ctx.addPage(item.id))
                      }, "Add Doc", 8, _hoisted_14)
                    ]),
                    (index !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            class: "menu-link px-3",
                            onClick: ($event: any) => (_ctx.onMove(item , _ctx.menuData[index - 1].id))
                          }, "Move Up", 8, _hoisted_16)
                        ]))
                      : _createCommentVNode("", true),
                    (index !== _ctx.menuData.length -1 )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            class: "menu-link px-3",
                            onClick: ($event: any) => (_ctx.onMove(item, _ctx.menuData[index + 1].id))
                          }, " Move Down", 8, _hoisted_18)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["menu-sub menu-sub-accordion menu-active-bg", {'show': item.active}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, childIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: child.id,
                  class: _normalizeClass(["menu-item menu-item-custom-child", {'active show ': child.active}]),
                  style: {"position":"relative"}
                }, [
                  _createVNode(_component_MenuItem, {
                    item: child,
                    onClick: ($event: any) => (_ctx.onClickItem(child))
                  }, null, 8, ["item", "onClick"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_QuickAction, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, [
                            (child.type ==='FOLDER')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0);",
                                  class: "menu-link px-3",
                                  onClick: ($event: any) => (_ctx.addPage(child.id))
                                }, " Add Doc", 8, _hoisted_22))
                              : _createCommentVNode("", true)
                          ]),
                          (childIndex !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0);",
                                  class: "menu-link px-3",
                                  onClick: ($event: any) => (_ctx.onMove(child, item.children[childIndex -1].id))
                                }, "Move Up", 8, _hoisted_24)
                              ]))
                            : _createCommentVNode("", true),
                          (childIndex !== item.children.length -1 )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0);",
                                  class: "menu-link px-3",
                                  onClick: ($event: any) => (_ctx.onMove(child, item.children[childIndex +1].id))
                                }, "Move Down", 8, _hoisted_26)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (page, childLast) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: page.id,
                        class: _normalizeClass(["menu-item menu-item-custom-child-last", {'active show ': page.active}]),
                        style: {"position":"relative"}
                      }, [
                        _createVNode(_component_MenuItem, {
                          item: page,
                          onClick: ($event: any) => (_ctx.onClickItem(page))
                        }, null, 8, ["item", "onClick"]),
                        (child.children.length> 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_component_QuickAction, null, {
                                  default: _withCtx(() => [
                                    (childLast !== 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                          _createElementVNode("a", {
                                            href: "javascript:void(0);",
                                            class: "menu-link px-3",
                                            onClick: ($event: any) => (_ctx.onMove(page, child.children[childLast -1].id))
                                          }, "Move Up", 8, _hoisted_31)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (childLast !== child.children.length -1 )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                          _createElementVNode("a", {
                                            href: "javascript:void(0);",
                                            class: "menu-link px-3",
                                            onClick: ($event: any) => (_ctx.onMove(child, child.children[childLast +1].id))
                                          }, "Move Down", 8, _hoisted_33)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ], 2))
              }), 128))
            ], 2)
          ], 2))
        }), 128))
      ])
    ], 512),
    _createVNode(_component_Panel, {
      name: _ctx.state.title,
      show: _ctx.state.showPanel,
      onClose: _ctx.onClosePanel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_ShortPageForm, {
              page: _ctx.state.model,
              onClosePanel: _ctx.onSavePage
            }, null, 8, ["page", "onClosePanel"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["name", "show", "onClose"])
  ], 64))
}